//AutoLogout added for session extension and automatic logout when inactive
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AlertDialog } from "../components/common/AlertDailog";
import { jwtDecode } from "jwt-decode";
import { baseURL } from "../api";
import { decodeToken } from "../utils/decodeToken";



interface AutoLogoutProps {
    children: any;
}

const timeoutEvents = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
];

const AutoLogout: React.FC<AutoLogoutProps> = ({ children }) => {

    let popEvents: any;

    const [openModal, setOpenModal] = useState(false);
    const [popUpCounter, setPopUpCounter] = useState(0);
    const [lastUiAccessTime, setlastUiAccessTime] = useState(new Date().getTime());
    const [accessToken, setAccessToken] = useState(Cookies.get('accessToken'))
    const [refreshToken, setRefreshToken] = useState(Cookies.get('refreshToken'))
    const { tokenExpiryPeriodInSeconds, tokenExpiryTime } = decodeToken(accessToken);
    const [jwtExpiryTime, setJwtExpiryTime] = useState(tokenExpiryTime * 1000)
    const [jwtExpiryPeriod, setJwtExpiryPeriod] = useState(tokenExpiryPeriodInSeconds)
    const [counter, setCounter] = useState(jwtExpiryPeriod);
    const [manualLogin, setManualLogin] = useState(false);

    const stayLoggedin = async () => {
        if (refreshToken) {
            const reauthHeaders: any = {
                "Content-Type": "application/json",
                token: refreshToken,
            };
            const reauth = await fetch(`${baseURL}/auth/refresh_token`, {
                method: "post",
                headers: reauthHeaders,
            });
            const reauthResponse = await reauth.json();
            const access_token = reauthResponse["access_token"];
            const refresh_token = reauthResponse["refresh_token"];
            const { tokenExpiryPeriodInSeconds, tokenExpiryTime } = decodeToken(access_token);
            setJwtExpiryPeriod(tokenExpiryPeriodInSeconds)
            setJwtExpiryTime(tokenExpiryTime * 1000)
            Cookies.set("accessToken", access_token, {
                expires: jwtExpiryPeriod / (24 * 60 * 60),
            });
            setAccessToken(access_token);
            Cookies.set("refreshToken", refresh_token, {
                expires: 15 / (24 * 60),
            });
            setRefreshToken(refresh_token)
            setOpenModal(false);
            if (manualLogin) {
                setlastUiAccessTime(Math.floor(new Date().getTime() / 1000));
                setPopUpCounter(0);
            }
            setCounter(jwtExpiryPeriod)
            removeTimeoutEvents()
        }
    }

    const handleLogout = async () => {
        if (accessToken) {
            const decodedJwtToken = jwtDecode(accessToken)
            const email = decodedJwtToken.sub;
            const headers: any = {
                'Content-Type': 'application/json',
                'access-token': Cookies.get('accessToken'),
                'refresh-token': Cookies.get('refreshToken')
            }
            const logoutCall = await fetch(`${baseURL}/auth/logout/${email}`, {
                method: 'post',
                headers,
            })
            const logoutResponse = await logoutCall.json();
            console.debug(logoutResponse);
            setOpenModal(false);
            Cookies.remove("accessToken");
        }
        Cookies.remove("refreshToken");
        removeTimeoutEvents();
        window.location.replace("/login");
    }

    useEffect(() => {
        popEvents = Object.values(timeoutEvents).forEach((item) => {
            window.addEventListener(item, () => {
                if (!openModal) {
                    setlastUiAccessTime(Math.floor(new Date().getTime() / 1000));
                }
            });
        });
    }, [])

    const removeTimeoutEvents = () => {
        Object.values(timeoutEvents).forEach((item) => {
            window.removeEventListener(item, popEvents);
        });
    }


    useEffect(() => {
        const currentTimer: any = setInterval(() => {
            setCounter(Math.floor((jwtExpiryTime - new Date().getTime()) / 1000))
            handleCurrentTimer();
        }, 1000);
        return () => clearInterval(currentTimer);
    }, [counter]);


    useEffect(() => {
        const timer: any =
            popUpCounter > 0 && setInterval(() => setPopUpCounter(popUpCounter - 1), 1000);
        return () => clearInterval(timer);
    }, [popUpCounter]);

    const handleCurrentTimer = () => {
        const currentTime = Math.floor(new Date().getTime() / 1000);

        if ((currentTime - lastUiAccessTime) >= jwtExpiryPeriod - 10) {
            if ((counter <= 10 && counter > 0)) {
                if (!openModal) {
                    setOpenModal(true);
                    setPopUpCounter(10);
                }
                if (openModal && popUpCounter <= 0) {
                    handleLogout()
                }
            } else if (counter > 10) {
                if (!openModal) {
                    setOpenModal(true);
                    setPopUpCounter(10);
                }
                if (openModal && popUpCounter <= 0) {
                    handleLogout()
                }
            } else {
                if (openModal && popUpCounter <= 0) {
                    handleLogout()
                }
            }
        }
        else if ((currentTime - lastUiAccessTime) < jwtExpiryPeriod - 10) {
            if (counter <= 0) {
                setOpenModal(false);
                setManualLogin(false)
                stayLoggedin();
            }
            if (openModal && popUpCounter <= 0) {
                handleLogout()
            }
        } else {
            handleLogout()
        }
    }

    return (
        <>
            {children}
            <AlertDialog
                open={openModal}
                title="Session Timeout"
                description={`Your session is about to <strong>expire</strong>. Please choose an appropriate action to stay logged in or stand by for automatic log out.`}
                handleClose={handleLogout}
                handleConfirm={stayLoggedin}
                confirmBtn={`Stay Logged in (${popUpCounter})`}
                cancelBtn="Logout"
                zIndex='9999'
            />
        </>
    );
};

export default AutoLogout;

